import { Container } from './Updates.styles';

const UpdatesError = () => {
  return <Container>error on load updates</Container>;
};

export { UpdatesError };
